import { Injectable } from "@angular/core"
import { Router, Resolve, ActivatedRoute, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router'
import { Observable } from "rxjs/Observable"
import { Store } from "@ngrx/store/src/store";
import { AppState } from "@store/app-state";
import { Angular2TokenService } from 'angular2-token';
import { Actions } from "@ngrx/effects";
import { User } from "@models/user";
import { Enquiry } from "@models/enquiry";
import {
  POPULATE_CURRENT_USER_CONTACT,
  FETCH_CURRENT_USER_CONTACT
} from "@reducers/user";
import {
  POPULATE_ACTIVE_ENQUIRY,
  FETCH_ENQUIRY_BY_GUID
} from "@reducers/enquiries";
import { POPULATE_CONSTANTS, FETCH_CONSTANTS } from "@reducers/constants";

@Injectable()
export class OnlineEnrolmentViewResolver implements Resolve<boolean> {

  constructor(
    private store: Store<AppState>,
    private actions: Actions,
    private router: Router,
    private tokenService: Angular2TokenService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const user = this.tokenService.validateToken()
      .take(1)
      .switchMap(
        (res: any) => {
          const user = User.initFromCurrentUserData(this.tokenService.currentUserData)
          if (user.contactId) {
            this.store.dispatch({ type: FETCH_CURRENT_USER_CONTACT, payload: user.contactId })
            return this.actions
                .ofType(POPULATE_CURRENT_USER_CONTACT)
                .take(1)
                .mapTo(true)
          }
          else {
            return Observable.of(true)
          }
      })
      .catch((err: any) => { return Observable.of(true) })

    let enquiry
    if (route.queryParams.guid) {
      this.store.dispatch({ type: FETCH_ENQUIRY_BY_GUID, payload: route.queryParams.guid })
      enquiry = this.actions
        .ofType(POPULATE_ACTIVE_ENQUIRY)
        .take(1)
        .mapTo(true)

    }
    else {
      this.store.dispatch({ type: POPULATE_ACTIVE_ENQUIRY, payload: new Enquiry() })
      enquiry = Observable.of(true)
    }

    const constants = this.actions
      .ofType(POPULATE_CONSTANTS)
      .take(1)
      .mapTo(true)
    this.store.dispatch({ type: FETCH_CONSTANTS })

    return Observable.zip(user, enquiry, constants).take(1).mapTo(true)
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/resolvers/online-enrolment-view.ts